import styled, { css } from 'styled-components';

interface MenuItemProps {
  isLogoutItem?: boolean;
}

export const Container = styled.div<MenuItemProps>`
  margin: 0;
  padding: ${({ theme }) => `${theme.spacing.four} ${theme.spacing.six}`};
  gap: ${({ theme }) => theme.spacing.four};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.gray.six};
  font-size: ${({ theme }) => theme.fontSize.small};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  cursor: pointer;

  &:hover {
    background-color: #f5f5f5;
  }

  svg {
    font-size: ${({ theme }) => theme.spacing.five};
    color: ${({ theme }) => theme.colors.gray.six};
  }

  ${({ theme, isLogoutItem }) =>
    isLogoutItem &&
    css`
      border-top: 1px solid ${theme.colors.gray.one};
    `};
`;

export const Text = styled.span`
  color: ${({ theme }) => theme.colors.gray.six};
  font-size: ${({ theme }) => theme.fontSize.regular};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
`;
